import type { ListBuilderList } from '../../../types';

/**
 * Awaiting Info — SRs with at least one line in `pending_info`.
 * Surfaces requests that are blocked on requestor clarification so
 * the buyer (or whoever's chasing) can see them in one place
 * without having to scan every SR detail page.
 *
 * Locks the line-status filter to a single value rather than the
 * SR-status filter — pending_info is intentionally a line-level
 * sub-state that does NOT escalate the SR's master status (see
 * `deriveSourcingRequestStatus` for why), so a pending-info line
 * can sit inside any non-cancelled SR. The kanban shows these in
 * their normal column with a chip indicator (separate work).
 */
export const awaitingInfoList: ListBuilderList = {
	id: 'default-sourcing-requests-awaiting-info',
	cacheTTL: 300000,
	name: 'Awaiting Info',
	type: 'default',
	active: true,
	sortOrder: 4,
	defaultSortId: 'column-sr-target-date-asc',
	filterRules: {
		sourcingRequestAssignedUser: {
			defaultValue: [{ id: 'ME', label: 'Me' }],
			lockedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'sourcing_requests:view:any', negated: true },
				],
			},
			hiddenIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'sourcing_requests:view:any', negated: true },
				],
			},
		},
		sourcingRequestLineStatus: {
			defaultValue: [{ id: 'pending_info', label: 'Pending Info' }],
			locked: true,
			hidden: true,
		},
	},
	inheritsFrom: 'default-sourcing-requests-all',
};
